import React, { PropTypes } from 'react';
import { NitroAccordion } from 'nitro-components';

import FeatureList from './FeatureList';

const Lease = ({ selectedLeaseOptions, active }) => {

  const list = selectedLeaseOptions.filter(o => o).map(option =>
    `${option.extra}: ${option.value}`
  );

  if (!list || !list.length) {
    return null;
  }

  return (
    <NitroAccordion
      title="Lease details"
      details={<FeatureList list={list} />}
      active={active}
    />
  );
};

Lease.propTypes = {
  selectedLeaseOptions: PropTypes.array.isRequired,
  active: PropTypes.bool,
};

export default Lease;



// WEBPACK FOOTER //
// ./src/features/corporate-quote/components/accordions/Lease.js